import React, { memo } from 'react';
import { browserInfo } from '../../web-notification-browser';
import SubscribedMatchLoader from '../subscriptions/SubscribedMatchLoader';
import SubscribedMatchesList from './LoadableSubscriptionMatchesList';
import IntersectionObserver from '@/ui/IntersectionObserver';

function SubscriptionMatches({ visible }) {
    if (!browserInfo().browserSupported) {
        return null;
    }
    if (!visible) {
        return <SubscribedMatchLoader />;
    }

    return <SubscribedMatchesList />;
}

export const IOSubscriptionMatches = memo(function IOSubscriptionMatches() {
    return <IntersectionObserver>{visible => <SubscriptionMatches visible={visible} />}</IntersectionObserver>;
});
